// カスタムマルチセレクトの実装
class CustomMultiSelect {
  constructor(selectElement) {
    this.selectElement = selectElement;
    this.options = Array.from(selectElement.options).filter(
      (opt) => opt.value !== "",
    );
    // 既に選択されているオプションを初期値として設定
    this.selectedValues = new Set(
      Array.from(selectElement.selectedOptions)
        .map(opt => opt.value)
        .filter(val => val !== "")
    );
    this.placeholder =
      selectElement.getAttribute("data-placeholder") || "選択してください";
    this.searchPlaceholder = "検索...";
    // 検索フィールドの表示/非表示を制御
    this.showSearch = selectElement.getAttribute("data-search") !== "false";

    this.init();
  }

  init() {
    // 元のselectを非表示
    this.selectElement.style.display = "none";

    // カスタムマルチセレクトを作成
    this.wrapper = document.createElement("div");
    this.wrapper.className = "custom-multiselect";

    // ドロップダウンボタン
    this.dropdownButton = document.createElement("div");
    this.dropdownButton.className = "multiselect-dropdown";
    this.dropdownButton.innerHTML = `
      <span class="multiselect-dropdown-text placeholder">${this.placeholder}</span>
      <span class="multiselect-dropdown-arrow"></span>
    `;

    // ドロップダウンリスト
    this.dropdownList = document.createElement("div");
    this.dropdownList.className = "multiselect-dropdown-list";

    // 検索ボックス（showSearchがtrueの場合のみ作成）
    if (this.showSearch) {
      this.searchBox = document.createElement("div");
      this.searchBox.className = "multiselect-dropdown-search";
      this.searchBox.innerHTML = `<input type="text" placeholder="${this.searchPlaceholder}">`;
      this.searchInput = this.searchBox.querySelector("input");
    }

    // オプションリスト
    this.optionsList = document.createElement("div");
    this.renderOptions();

    if (this.showSearch) {
      this.dropdownList.appendChild(this.searchBox);
    }
    this.dropdownList.appendChild(this.optionsList);

    this.wrapper.appendChild(this.dropdownButton);
    this.wrapper.appendChild(this.dropdownList);

    // 元のselectの後に挿入
    this.selectElement.parentNode.insertBefore(
      this.wrapper,
      this.selectElement.nextSibling,
    );

    // イベントリスナー
    this.attachEventListeners();

    // 初期選択状態を反映
    this.updateDropdownText();
  }

  renderOptions(filterText = "") {
    this.optionsList.innerHTML = "";

    const filteredOptions = this.options.filter((option) => {
      const text = option.textContent.toLowerCase();
      return text.includes(filterText.toLowerCase());
    });

    if (filteredOptions.length === 0) {
      this.optionsList.innerHTML =
        '<div class="multiselect-no-results">該当する項目がありません</div>';
      return;
    }

    filteredOptions.forEach((option) => {
      const item = document.createElement("div");
      item.className = "multiselect-dropdown-list-item";
      item.dataset.value = option.value;

      if (this.selectedValues.has(option.value)) {
        item.classList.add("selected");
      }

      item.innerHTML = `
        <span class="multiselect-checkbox"></span>
        <span class="multiselect-option-text">${option.textContent}</span>
      `;

      this.optionsList.appendChild(item);
    });
  }

  attachEventListeners() {
    // ドロップダウンボタンのクリック
    this.dropdownButton.addEventListener("click", (e) => {
      e.stopPropagation();
      this.toggleDropdown();
    });

    // オプションのクリック
    this.optionsList.addEventListener("click", (e) => {
      const item = e.target.closest(".multiselect-dropdown-list-item");
      if (item) {
        e.stopPropagation();
        this.toggleOption(item);
      }
    });

    // 検索（検索フィールドが有効な場合のみ）
    if (this.showSearch && this.searchInput) {
      this.searchInput.addEventListener("input", (e) => {
        this.renderOptions(e.target.value);
      });

      this.searchInput.addEventListener("click", (e) => {
        e.stopPropagation();
      });
    }

    // 外側クリックで閉じる
    document.addEventListener("click", (e) => {
      if (!this.wrapper.contains(e.target)) {
        this.closeDropdown();
      }
    });
  }

  toggleDropdown() {
    const isActive = this.dropdownButton.classList.contains("active");

    if (isActive) {
      this.closeDropdown();
    } else {
      this.openDropdown();
    }
  }

  openDropdown() {
    this.dropdownButton.classList.add("active");
    this.dropdownList.classList.add("show");
    if (this.showSearch && this.searchInput) {
      this.searchInput.value = "";
      this.searchInput.focus();
    }
    this.renderOptions();
  }

  closeDropdown() {
    this.dropdownButton.classList.remove("active");
    this.dropdownList.classList.remove("show");
  }

  toggleOption(item) {
    const value = item.dataset.value;

    if (this.selectedValues.has(value)) {
      this.selectedValues.delete(value);
      item.classList.remove("selected");
    } else {
      this.selectedValues.add(value);
      item.classList.add("selected");
    }

    this.updateSelectElement();
    this.updateDropdownText();
  }

  updateSelectElement() {
    // 元のselectの選択状態を更新
    Array.from(this.selectElement.options).forEach((option) => {
      option.selected = this.selectedValues.has(option.value);
    });

    // changeイベントを発火
    const event = new Event("change", { bubbles: true });
    this.selectElement.dispatchEvent(event);
  }

  updateDropdownText() {
    const textElement = this.dropdownButton.querySelector(
      ".multiselect-dropdown-text",
    );

    if (this.selectedValues.size === 0) {
      textElement.textContent = this.placeholder;
      textElement.classList.add("placeholder");
    } else {
      const selectedOptions = this.options.filter((opt) =>
        this.selectedValues.has(opt.value),
      );
      const selectedTexts = selectedOptions.map((opt) => opt.textContent);

      if (selectedTexts.length <= 2) {
        textElement.textContent = selectedTexts.join(", ");
      } else {
        textElement.textContent = `${selectedTexts.length}件選択中`;
      }

      textElement.classList.remove("placeholder");
    }
  }

  destroy() {
    this.wrapper.remove();
    this.selectElement.style.display = "";
  }
}

// 初期化関数
function initCustomMultiSelect() {
  document
    .querySelectorAll('select[data-multiselect="true"]')
    .forEach((select) => {
      if (!select.customMultiSelect) {
        select.customMultiSelect = new CustomMultiSelect(select);
      }
    });
}

// DOMContentLoadedイベントで初期化
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initCustomMultiSelect);
} else {
  initCustomMultiSelect();
}

// グローバルに公開（必要な場合）
window.CustomMultiSelect = CustomMultiSelect;
window.initCustomMultiSelect = initCustomMultiSelect;
